import { defineMessages } from 'react-intl'

const messages = {
  switchProductControl: {
    id: 'app.components.product-control-switcher.switch-product-control',
    defaultMessage: 'Switch product control',
  },
}

export default defineMessages(messages)
